import { useState, useRef } from 'react';
import bgImage from '../../../assets/img/mine/HeroImage2.png';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import MotionNavLink from '../../MotionLink';
const Home = () => {
  const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
  };

  const zoomIn = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } }
  };

  const fadeInRight = (delay) => ({
    initial: { opacity: 0, x: 50 },
    whileInView: { opacity: 1, x: 0 },
    transition: { duration: 0.5, delay },
    viewport: { once: false, amount: 0.2 }
  });

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    section?.scrollIntoView({behavior : "smooth"});
  }

  const cards = [
    {
      id: 1,
      title: 'AI-Driven Insights',
      description: 'Leverage data-driven AI to unlock deep business insights, optimize processes, and stay ahead of the competition.',
      imgSrc: 'img/mine/Gunadhya tech Icons 01.png',
      bgColor: 'bg-color-dark',
      delay: 0.1
    },
    {
      id: 2,
      title: 'Intelligent Automation',
      description: 'Automate repetitive tasks and enhance efficiency with AI-powered workflows tailored to your needs.',
      imgSrc: 'img/mine/Gunadhya tech Icons 02.png',
      bgColor: 'bg-color-primary',
      delay: 0.2
    },
    {
      id: 3,
      title: 'Smart Decision-Making',
      description: 'Utilize advanced AI models to make informed, real-time decisions for better outcomes.',
      imgSrc: 'img/mine/Gunadhya tech Icons 03.png',
      bgColor: 'bg-color-dark',
      delay: 0.3
    }
  ];

  const listItems = [
    'Data-Driven Insights – Unlock deep analytical capabilities.',
    'Automation & Efficiency – Reduce manual effort, maximize output.',
    'Scalable AI Solutions – Designed to grow with your business.'
  ];

  const blogPosts = [
    {
      date: 'MARCH 18, 2025',
      title: 'Welcome to the Age of AI Transformation',
      link: 'demo-digital-agency-2-our-blog-post.html',
      description:
        'Revolutionize your business with AI-powered innovation. Experience intelligent automation, smart insights, and AI-driven decision-making.'
    },
    {
      date: 'MARCH 18, 2025',
      title: 'AI-Driven Insights',
      link: 'demo-digital-agency-2-our-blog-post.html',
      description: 'Leverage data-driven AI to unlock deep business insights, optimize processes, and stay ahead of the competition.'
    },
    {
      date: 'MARCH 18, 2025',
      title: 'Intelligent Automation',
      link: 'demo-digital-agency-2-our-blog-post.html',
      description: 'Automate repetitive tasks and enhance efficiency with AI-powered workflows tailored to your needs.'
    },
    {
      date: 'MARCH 18, 2025',
      title: 'Smart Decision-Making',
      link: 'demo-digital-agency-2-our-blog-post.html',
      description: 'Utilize advanced AI models to make informed, real-time decisions for better outcomes.'
    },
    {
      date: 'MARCH 18, 2025',
      title: 'AI Consulting & Development',
      link: 'demo-digital-agency-2-our-blog-post.html',
      description: 'Unlock AI-driven innovation with expert strategy and tailored solutions.'
    }
  ];
  const [activeFilter, setActiveFilter] = useState('*');

  const projects = [
    {
      id: 2,
      title: 'AI Virtual Assistance',
      categories: ['ai-virtual-assistance'],
      image: 'img/mine/AI chatbot.png',
      link: '/chatbotbase',
      description:
        'Enhance your business with AI-powered virtual assistance. Our chatbot provides real-time support, automates responses, and improves customer engagement. Experience seamless and intelligent communication with our advanced AI solution.'
    },
    {
      id: 3,
      title: 'Job Description + AI',
      categories: ['job-description-ai'],
      image: 'img/mine/Job dicrption genrator.png',
      link: '/jobdescription/jobdescriptionUtility',
      description:
        'Crafts precise and tailored job descriptions effortlessly, ensuring that the job requirements and responsibilities are clearly defined to attract the right candidates.'
    },
    {
      id: 4,
      title: 'Pick My Stack',
      categories: ['pick-my-stack'],
      image: 'img/mine/Tech Stack Predictor.png',
      link: '/techpred/home',
      description:
        'Suggests optimal technology stacks for projects based on specific requirements, industry standards, and project complexity to maximize performance and scalability.'
    },
    {
      id: 5,
      title: 'Prescription Detector',
      categories: ['prescription-detector'],
      image: 'img/mine/robot-working-pharmaceutical-field-instead-humans.jpg',
      link: '/prescription/prescriptionUtility',
      description:
        'Leverage AI to extract medication names, dosages, and instructions from handwritten or printed prescriptions—optimized for healthcare accuracy, efficiency, and scalability.'
    },
    {
      id: 6,
      title: 'LinkedIn Post Assistant',
      categories: ['linkedin-post'],
      image: 'img/mine/Linkedinpost.jpg',
      link: '/linkedinpost',
      description:
        'Not sure what to post on LinkedIn? Let AI help you out! Create thoughtful, attention-grabbing posts in no time — perfect for busy professionals like you.'
    },
    {
      id: 7,
      title: 'Recommendation Engine',
      categories: ['recommendation-engine'],
      image: 'img/mine/recommendationEngine.jpg',
      link: '/recommendation/recommendationUtility',
      description:
        'Our AI delivers personalized toy suggestions in seconds, based on your child’s unique interests and preferences. Just answer a few simple questions—our system matches your input with the best-fit toys, making discovery fun, fast, and effortless'
    },
    {
      id: 8,
      title: 'Lesson Planner',
      categories: ['lesson-planner'],
      image: 'img/mine/lessonplanner.jpg',
      link: '/lessonplanner',
      description:
        'Lesson Planner AI helps educators quickly generate customized lesson plans by inputting topic, grade, board, and teaching preferences. It streamlines planning and ensures content is tailored for concept clarity, activities, or assessments—enhancing classroom effectiveness.'
    },
    {
      id: 9,
      title: 'Smart AI Virtual Assistance',
      categories: ['crawling-chatbot'],
      image: 'img/mine/crawling_chatbot.jpg',
      link: '/crawling/crawlingChatbotUtility',
      description:
        'Build a smart AI-powered chatbot trained directly from your website’s content. Just enter a URL — our system automatically crawls the site, extracts text, creates a knowledge base, and generates a chatbot you can embed anywhere.'
    }
    // {
    //   id: 10,
    //   title: 'Real Estate Lead Manager',
    //   categories: ['real-estate-lead-manager'],
    //   image: 'img/mine/realestate.jpg',
    //   link: '/realestate/landing-page',
    //   description:
    //     'Build a smart AI-powered chatbot trained directly from your website’s content. Just enter a URL — our system automatically crawls the site, extracts text, creates a knowledge base, and generates a chatbot you can embed anywhere.'
    // }
  ];

  const categories = [
    { label: 'View All', value: '*' },
    { label: 'AI Virtual Assistance', value: 'ai-virtual-assistance' },
    { label: 'Job Description + AI', value: 'job-description-ai' },
    { label: 'Pick My Stack', value: 'pick-my-stack' },
    { label: 'Prescription Detector', value: 'prescription-detector' },
    { label: 'Linkedin Post Assistant', value: 'linkedin-post'},
    { label: 'Recommendation Engine', value: 'recommendation-engine'},
    { label: 'Lesson Planner', value: 'lesson-planner' },
    { label: 'Smart AI Virtual Assistance', value: 'crawling-chatbot' },
    // { label: 'Real Estate Lead Manager', value: 'real-estate-lead-manager' }
  ];

  const filteredProjects = activeFilter === '*' ? projects : projects.filter((project) => project.categories.includes(activeFilter));

  const containerRef = useRef(null);

  const handleScrollClick = (value) => {
    setActiveFilter(value);
    if (containerRef.current) {
      const offset = -50;
      const top = containerRef.current.getBoundingClientRect().top + window.scrollY + offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div role="main" className="main">
      <section
        className="section custom-circles-container section-angled bg-dark border-0 m-0"
        style={{
          backgroundImage: `url('img/mine/HeroImage.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <motion.span
          className="custom-circle custom-circle-1 bg-color-light custom-circle-blur"
          variants={fadeInRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ delay: 0.1 }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-2 bg-color-primary"
          variants={zoomIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ delay: 0.2 }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-3 bg-color-primary"
          variants={zoomIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ delay: 0.3 }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-1 bg-color-light custom-circle-blur"
          variants={fadeInLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ delay: 0.4 }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-2 bg-color-primary"
          variants={zoomIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ delay: 0.5 }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-3 bg-color-primary"
          variants={zoomIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ delay: 0.6 }}
        ></motion.span>

        <div className="section-angled-layer-bottom section-angled-layer-increase-angle bg-light"></div>
        <div className="section-angled-content h-100">
          <div className="container pt-md-5 pb-lg-4 mt-5 mb-lg-5">
            <div className="row pb-lg-5 mt-5 mb-lg-5">
              <div className="col-lg-7 pt-5 pt-md-0 pb-lg-5 mt-5 mb-md-5">
                <motion.h1
                  className="custom-title-with-icon custom-title-with-icon-primary font-weight-normal  text-5 mb-0"
                  variants={{
                    hidden: { opacity: 0, y: 30 },
                    visible: {
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.6, delay: 0.6 }
                    }
                  }}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.2 }}
                  style={{ color: '#FFF5EE' }}
                >
                  Welcome to the Age of AI Transformation
                </motion.h1>
                <motion.h2
                  className="text-color-light font-weight-extra-bold  line-height-2 mb-4"
                  variants={{
                    hidden: { opacity: 0, y: 30 },
                    visible: {
                      opacity: 1,
                      y: 0,
                      transition: { duration: 0.6, delay: 0.85 }
                    }
                  }}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.2 }}
                >
                  Revolutionize Your Business with AI-Powered Innovation.
                </motion.h2>
                <MotionNavLink
                  onClick = {(e) => {
                    e.preventDefault();
                    scrollToSection("utlitiySection")
                  }}
                  to="/"
                  data-hash
                  data-hash-offset="0"
                  data-hash-offset-lg="100"
                  className="btn btn-outline custom-btn-outline btn-primary rounded-0 font-weight-semibold text-color-light bg-color-hover-primary custom-btn-with-arrow text-4 btn-px-4 py-3 mt-2"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.6, delay: 1.1 }
                  }}
                  viewport={{ once: false, amount: 0.2 }}
                >
                  Explore Utilities
                </MotionNavLink>
              </div>
            </div>
            <div className="spacer py-5 mt-lg-5 mb-md-5"></div>
          </div>
        </div>
      </section>

      <section className="custom-cards p-relative mb-5 pb-5 z-index-2">
        <div className="container">
          <div className="row">
            {cards.map(({ id, title, description, imgSrc, bgColor, delay }) => (
              <div key={id} className="col-lg-4 col-custom-cards">
                <motion.div
                  className={`card border-0 ${bgColor} rounded-0 z-index-1 p-5`}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.6, delay }
                  }}
                >
                  <div className="card-body d-flex flex-column justify-content-center align-items-center p-0 my-3">
                    <img src={imgSrc} alt={title} className="mb-5" />
                    <h1 className="card-title custom-text-8 font-weight-bold text-color-light text-center mb-3">{title}</h1>
                    <p className="card-text text-center custom-text-4 font-weight-lighter text-color-light">{description}</p>
                  </div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="our-approach py-5 mb-4 mb-xl-5 mt-4 mt-xl-0 p-relative z-index-1" id="intro">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-xl-4 d-flex flex-column justify-content-center align-items-start">
              <motion.h1
                className="custom-text-10 mb-4 pb-2 font-weight-bold custom-title-with-icon custom-title-with-icon-primary"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.6, delay: 0.1 }
                }}
                viewport={{ once: false, amount: 0.2 }}
              >
                Our Approach
              </motion.h1>

              <motion.p
                className="custom-font-tertiary custom-text-6 line-height-6 font-weight-medium"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.6, delay: 0.2 }
                }}
                viewport={{ once: false, amount: 0.2 }}
              >
                We leverage cutting-edge AI to streamline workflows, enhance decision-making, and drive innovation.
              </motion.p>

              <motion.p
                className="custom-text-3"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  transition: { duration: 0.6, delay: 0.4 }
                }}
                viewport={{ once: false, amount: 0.2 }}
              >
                Our tailored solutions empower businesses to stay ahead in a rapidly evolving digital landscape.
              </motion.p>
            </div>
            <div className="col-lg-4 py-4 py-lg-0">
              <div className="approach-img bg-color-dark">
                <div className="custom-circle custom-circle-1"></div>
                <div className="custom-circle custom-circle-2 bg-color-dark"></div>
                {[...Array(3)].map((_, index) => (
                  <motion.span
                    key={index}
                    className={`custom-circle custom-circle-our-approach-deco-${index + 1} p-absolute d-block`}
                    initial={{ scale: 0 }}
                    whileInView={{
                      scale: 1,
                      transition: { duration: 0.6, delay: 0.1 }
                    }}
                    viewport={{ once: false, amount: 0.2 }}
                    style={{ backgroundColor: '#2596c694' }}
                  />
                ))}
              </div>
            </div>
            <div className="col-lg-6 col-xl-4 d-flex align-items-center mt-4 mt-lg-0">
              <ul className="custom-list list-unstyled ms-xl-2 ps-xl-1">
                {listItems.map((item, index) => (
                  <motion.li
                    key={index}
                    className="font-weight-medium custom-text-4 mb-4"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                      transition: { duration: 0.6, delay: index * 0.2 }
                    }}
                    viewport={{ once: false, amount: 0.2 }}
                  >
                    {item}
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id='utlitiySection' className="py-5 bg-color-secondary" ref={containerRef}>
        <div className="container sticky-container mt-xl-3">
          <div className="row justify-content-between">
            {/* Projects */}
            <div className="col-xl-9 our-work" id="ourWork">
              <div className="sort-destination w-100">
                {filteredProjects.map((project) => (
                  <div key={project.id} className="row w-100 mb-4">
                    <div className="col-sm-12 custom-our-work overlay overlay-op-9 overlay-show p-0">
                      <NavLink to={project.link} className="d-block h-100">
                        <img src={project.image} alt={project.title} className="w-100 h-100" />
                        <div className="w-100 custom-our-work-text px-5 py-3 d-flex align-items-end position-absolute bottom-0">
                          <div className="text-start position-relative z-index-2 mb-3">
                            <h4 className="text-color-light font-weight-bold mb-2 text-5">{project.title}</h4>
                            <p className="text-uppercase text-color-quaternary mb-3">{project.description}</p>
                            <span className="custom-text-4 font-weight-semibold m-0 p-0 text-color-light">View Work</span>
                          </div>
                        </div>
                      </NavLink>
                    </div>
                  </div>
                ))}
                {filteredProjects.length === 0 && <p className="text-center">No projects found</p>}
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-xl-3 bg-color-dark position-relative">
              <div
                className="side-menu-our-work sidebar mb-5"
                style={{
                  position: 'sticky',
                  top: '150px',
                  maxHeight: `calc(100vh - 150px)`,
                  overflowY: 'auto'
                }}
              >
                <h1 className="text-color-light custom-text-10 font-weight-bold custom-title-with-icon custom-title-with-icon-primary">
                  Our Utilities
                </h1>
                <ul className="list-unstyled sort-source">
                  {categories.map((category) => (
                    <li key={category.value} className="nav-item">
                      <NavLink
                        onClick={() => handleScrollClick(category.value)}
                        className="text-decoration-none mb-2 py-0 d-block"
                        style={{
                          cursor: 'pointer',
                          color: 'white',
                          fontWeight: activeFilter === category.value ? 'bold' : 'normal'
                        }}
                      >
                        {category.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="our-insights bg-color-tertiary p-relative py-5">
        <motion.span
          className="custom-circle custom-circle-2 bg-color-primary"
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: false, amount: 0.2 }}
        ></motion.span>

        <motion.span
          className="custom-circle custom-circle-3 bg-color-primary"
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: false, amount: 0.2 }}
        ></motion.span>
        <div className="container py-5">
          <div className="row">
            <div className="col">
              <motion.h4
                className="text-color-dark custom-text-10 font-weight-bold text-center custom-title-with-icon-center custom-title-with-icon custom-title-with-icon-primary pb-5 mb-5 "
                {...fadeInRight(0.2)}
              >
                Our Insights
              </motion.h4>
            </div>
          </div>

          {blogPosts.map((item, index) => (
            <div className="row" key={index}>
              <div className="col pb-5">
                <article>
                  <motion.p className="custom-font-tertiary text-uppercase custom-text-2 mb-1" {...fadeInRight(0.2)}>
                    {item.date}
                  </motion.p>
                  <motion.h4 className=" custom-text-8 font-weight-bold mb-3" {...fadeInRight(0.4)}>
                    <NavLink to="/our-insight" className="text-color-dark text-color-hover-primary">
                      {item.title}
                    </NavLink>
                  </motion.h4>
                  <motion.p className="custom-text-4 mb-2" {...fadeInRight(0.6)}>
                    {item.description}
                  </motion.p>
                  <MotionNavLink
                    to="/our-insight"
                    className="text-color-primary text-color-hover-secondary custom-text-4 font-weight-bold text-decoration-underline"
                    {...fadeInRight(0.8)}
                  >
                    Read More...
                  </MotionNavLink>
                </article>
              </div>
            </div>
          ))}

          <div className="row">
            <div className="col">
              <MotionNavLink
                to="/our-insight"
                className="btn btn-outline custom-btn-outline btn-primary rounded-0 text-color-dark custom-text-4 bg-color-hover-transparent text-color-hover-light font-weight-semibold custom-btn-with-arrow px-4 py-3 "
                {...fadeInRight(0.4)}
              >
                View More
              </MotionNavLink>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;
